import { Model } from 'backbone';

export class GauntletModel extends Model {
	get defaults() {
		return {
			sended: [],
			rank: 0,
			total_margin: 0,
			is_active: false,
			active_users: 0,
			total_users: 0
		};
	}

	initialize() {
		this.prefix = 'gauntlet/';
		return this.setSnapshotUrl();
	}

	setSnapshotUrl() {
		this.url = 'snapshot';
		return this;
	}

	setSaveUrl() {
		this.url = 'save';
		return this;
	}

	setRemoveUrl() {
		this.url = 'remove';
		return this;
	}
}

export default GauntletModel;